import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import Cookies from 'universal-cookie';
import _ from 'lodash';
import { RenderField, RenderCheckboxRadioField, RenderHiddenField, RenderSubmitButton } from '../../../common/form';
import * as Validations from '../../../common/form/commonValidations';
import { updateGuestRsvp } from '../../../../actions/PublicWebsiteActions';

/**
 * Guest Group RSVP form
 * TODO: Refactor like fucking crazy
 */

const RenderGuest = ({ fields, mealOptions, selector }) => {
  const renderNameUnknownPlaceholder = fieldType => (
    <div className={`form-group ${fieldType} no-margin-bottom`}>
      <label htmlFor={`rsvp-${fieldType}-placeholder`}>{fieldType === 'first-name' ? 'First Name' : 'Last Name'}</label>
      <input
        style={{ backgroundColor: '#F7F7F7' }}
        className="form-control disabled"
        id={`rsvp-${fieldType}-placeholder`}
        type="text"
        disabled
      />
    </div>
  );

  const getRsvpStatus = (index) => {
    const status = selector(`guests[${index}].rsvp`);
    return status;
  };

  const getNameRequiredProps = (index) => {
    const nameUnknown = selector(`guests[${index}].name_unknown`);
    const relationshipType = selector(`guests[${index}].relationship_type`);
    const isPrimary = (relationshipType === 'PRIMARY');
    const hasDeclined = (getRsvpStatus(index) === 'DECLINED');
    const validation = { validate: Validations.REQUIRED, required: true };

    if (!isPrimary) {
      return (nameUnknown || hasDeclined) ? {} : validation;
    }
    return validation;
  };

  const renderNameInput = (index) => {
    const relationshipType = selector(`guests[${index}].relationship_type`);
    const nameUnknown = selector(`guests[${index}].name_unknown`);
    let placeholder = '';
    if (relationshipType === 'PARTNER') {
      placeholder = 'Guest';
    } else if (relationshipType === 'CHILD') {
      placeholder = 'Child';
    }
    if (nameUnknown) {
      return (
        <div className="form-group">
          {renderNameUnknownPlaceholder('first-name')}
          {renderNameUnknownPlaceholder('last-name')}
          {relationshipType === 'PARTNER' &&
            <Field
              className="name-unknown margin-top"
              id={`guest-form-guest-${index}-name-unknown`}
              name={`guests[${index}].name_unknown`}
              component={RenderCheckboxRadioField}
              type="checkbox"
              label="Guest Name Unknown"
              inline
              styleOverride
              parse={() => false}
            />
          }
        </div>
      );
    }

    return (
      <div className="form-group">
        <Field
          id={`guest-form-guest-${index}-first-name`}
          name={`guests[${index}].first_name`}
          type="text"
          className={relationshipType === 'PARTNER' ? 'first-name no-margin-bottom' : 'first-name'}
          component={RenderField}
          label="First Name"
          {...getNameRequiredProps(index)}
          placeholder={`${placeholder} First Name`}
          normalize={(value) => {
            if (value === '') {
              return null;
            }
            return value;
          }}
        />
        <Field
          id={`guest-form-guest-${index}-last-name`}
          name={`guests[${index}].family_name`}
          type="text"
          component={RenderField}
          label="Last Name"
          className={relationshipType === 'PARTNER' ? 'last-name no-margin-bottom' : 'last-name'}
          {...getNameRequiredProps(index)}
          placeholder={`${placeholder} Last Name`}
          normalize={(value) => {
            if (value === '') {
              return null;
            }
            return value;
          }}
        />
        {selector(`guests[${index}].relationship_type`) === 'PARTNER' && (
          <Field
            className="name-unknown margin-top"
            id={`guest-form-guest-${index}-name-unknown`}
            name={`guests[${index}].name_unknown`}
            component={RenderCheckboxRadioField}
            type="checkbox"
            label="Guest Name Unknown"
            inline
            styleOverride
            parse={() => true}
          />
        )}
      </div>
    );
  };

  const rsvpResponseValidation = (value) => {
    if (value === 'NO_RESPONSE') {
      return 'Required';
    }
    return undefined;
  };

  return (
    <ul className="list-unstyled">
      {fields.map((guest, index) =>
        <li key={index} className="rsvp-guest">
          <Field
            id={`guest-form-guest-${index}-id`}
            name={`guests[${index}].id`}
            type="hidden"
            component={RenderHiddenField}
            required
            validate={Validations.REQUIRED}
          />
          {renderNameInput(index)}
          <div className="form-group attending">
            <h4 className="padding-top">Are you able to attend? <span className="text-danger danger-asterisk">*</span></h4>
            <Field
              id={`guest-form-guest-${index}-rsvp-attending`}
              name={`guests[${index}].rsvp`}
              component={RenderCheckboxRadioField}
              type="radio"
              label="Yes, Will Attend"
              validate={[Validations.REQUIRED, rsvpResponseValidation]}
              styleOverride
              value="ATTENDING"
              inline
              required
            />
            <Field
              id={`guest-form-guest-${index}-rsvp-declined`}
              name={`guests[${index}].rsvp`}
              component={RenderCheckboxRadioField}
              type="radio"
              label="Declines With Regret"
              validate={[Validations.REQUIRED, rsvpResponseValidation]}
              styleOverride
              value="DECLINED"
              inline
              required
            />
          </div>
          {mealOptions && mealOptions.length > 0 && selector(`guests[${index}].rsvp`) !== 'DECLINED' &&
          <div className="form-group meal-options">
            <h4>Which Meal Option would you prefer? <span className="text-danger danger-asterisk">*</span></h4>
            {mealOptions && mealOptions.map((option, idx) => (
              <Field
                key={idx}
                id={`guest-form-guest-${index}-meal-option-${idx}`}
                name={`guests[${index}].meal_option_id`}
                component={RenderCheckboxRadioField}
                type="radio"
                label={_.capitalize(option.name)}
                validate={Validations.REQUIRED}
                styleOverride
                value={option.id}
                parse={val => parseInt(val, 10)}
                inline
                required
              />
            ))}
          </div>
          }
        </li>
      )}
    </ul>
  );
};

RenderGuest.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.shape({})),
  mealOptions: PropTypes.arrayOf(PropTypes.shape({})),
  selector: PropTypes.func.isRequired
};

const RenderRsvpQuestion = ({ question, index }) => (
  <li className="rsvp-question">
    <Field
      id={`rsvp-question-${question.id}-id`}
      name={`rsvp_answers[${index}].rsvp_question_id`}
      type="hidden"
      component={RenderHiddenField}
      required
      validate={Validations.REQUIRED}
    />
    <Field
      id={`rsvp-question-${question.id}-answer`}
      name={`rsvp_answers[${index}].answer`}
      type="text"
      component={RenderField}
      label={question.question}
      className="rsvp-question-field"
      maxChars={800}
      validate={Validations.MAX_LENGTH_800}
    />
  </li>
);

RenderRsvpQuestion.propTypes = {
  question: PropTypes.shape({}),
  index: PropTypes.number.isRequired
};

function resetGuestSearchesNotActedOn() {
  const cookies = new Cookies();
  cookies.remove('guestSearchesNotActedOn');
  cookies.remove('rsvpSearchDisabled');
}

const GuestRsvpForm = (props) => {
  const { guests, rsvpQuestions, pristine, submitting, valid, orderedIds, forPreview, mealOptions, selector, handleSubmit } = props;
  const onSubmit = (...args) => {
    resetGuestSearchesNotActedOn();
    return handleSubmit(...args);
  };

  return (
    <div>
      <form onSubmit={onSubmit} className="rsvp-guest-form" noValidate>
        <Field
          component={RenderHiddenField}
          type="hidden"
          name="guest_group_id"
          id="rsvp-guest_group_id"
        />
        <Field
          component={RenderHiddenField}
          type="hidden"
          name="wedding_account_id"
          id="rsvp-wedding_account_id"
        />
        {guests && !forPreview && (
          <RenderGuest fields={guests} mealOptions={mealOptions} selector={selector} />
        )}
        {forPreview && (
          <RenderGuest fields={[{ first_name: '', family_name: '' }]} mealOptions={mealOptions} selector={selector} />
        )}
        {rsvpQuestions && (
          <ul className="list-unstyled rsvp-questions">
            {!forPreview && rsvpQuestions.map((rsvpQuestion, index) => (
              <RenderRsvpQuestion key={rsvpQuestion.id} question={rsvpQuestion} index={index} />
            ))}
            {forPreview && orderedIds.map((questionId, index) => (
              <RenderRsvpQuestion key={index} index={index} question={rsvpQuestions[questionId]} />
            ))}
          </ul>
        )}
        <RenderSubmitButton pristine={pristine} submitting={submitting} valid={valid || true} className={'btn-wide'} value="Submit RSVP" />
      </form>
    </div>
  );
};

GuestRsvpForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  guests: PropTypes.arrayOf(PropTypes.shape({})),
  rsvpQuestions: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.shape({}))]),
  orderedIds: PropTypes.arrayOf(PropTypes.number),
  forPreview: PropTypes.bool,
  mealOptions: PropTypes.arrayOf(PropTypes.shape({})),
  selector: PropTypes.func.isRequired
};

const mapStateToProps = (state, ownProps) => {
  const answerInitialValues = !ownProps.forPreview && ownProps.rsvpQuestions ? ownProps.rsvpQuestions.map((question) => {
    const answers = state.publicWebsite.guestGroupRsvp.rsvp_answers;
    const rsvpAnswer = answers.filter(a => a.rsvp_question_id === question.id);
    return { rsvp_question_id: question.id, answer: rsvpAnswer.length > 0 ? rsvpAnswer[0].answer : undefined };
  }) : [];

  return {
    initialValues: {
      wedding_account_id: state.publicWebsite.guestGroupRsvp.wedding_account_id,
      guest_group_id: state.publicWebsite.guestGroupRsvp.guest_group_id,
      guests: state.publicWebsite.guestGroupRsvp.guests,
      rsvp_answers: answerInitialValues
    },
    guests: state.publicWebsite.guestGroupRsvp.guests,
    rsvpQuestions: ownProps.forPreview ? state.website.entities.byId : ownProps.rsvpQuestions,
    orderedIds: ownProps.forPreview ? state.website.entities.orderedIds : [],
    rsvpAnswers: state.publicWebsite.guestGroupRsvp.rsvp_answers,
    mealOptions: ownProps.mealOptions,
    selector: field => formValueSelector('GuestRsvpForm')(state, field)
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: guestRsvpRequest => dispatch(updateGuestRsvp(guestRsvpRequest)),
  validate: (values) => {
    if (ownProps.forPreview) return undefined;
    const { guests } = values;
    return guests.reduce((errors, guest, index) => {
      const nextErrors = { ...errors };
      if ((guest.rsvp === 'ATTENDING') && !guest.name_unknown) {
        if (!guest.first_name) {
          nextErrors[`guests[${index}].first_name`] = 'Required';
        }
        if (!guest.family_name) {
          nextErrors[`guests[${index}].family_name`] = 'Required';
        }
      }
      return nextErrors;
    }, {});
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({
  form: 'GuestRsvpForm',
})(GuestRsvpForm));



/** WEBPACK FOOTER **
 ** ./src/components/PublicWebsite/pages/rsvp/GuestRsvpForm.jsx
 **/